import React from 'react'

import './index.scss'

export default props => {
  const {
    onClick,
    className,
    children
  } = props

  const click = onClick ? onClick : (() => {})

  return <button className={['btn btn-outline-primary btn-bo-default', className].join(' ')} onClick={click}>{children || ''}</button>
}
